import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { fontFamilyOptions } from "./StyleTypographySection";

const IndexConfigSection = ({ config, handleInputChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <div className="param-group">
      <div className="param-group-header">
        <h3 className="param-group-title">
          <span>📑</span>
          {t("sections.index.title")}
        </h3>
      </div>

      <div className="grid grid-cols-1 gap-2 mb-2 md:grid-cols-2">
        <div className="form-group">
          <label className="form-label" htmlFor="indexAt">
            {t("sections.index.position")}
          </label>
          <select
            id="indexAt"
            className="form-input"
            value={config.indexAt || "start"}
            onChange={(e) => handleInputChange("indexAt", e.target.value)}
            disabled={disabled}
          >
            <option value="start">{t("sections.index.start")}</option>
            <option value="end">{t("sections.index.end")}</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="indexColumnCount">
            {t("sections.index.columnCount")}
          </label>
          <select
            id="indexColumnCount"
            className="form-input"
            value={config.indexOptions?.columnCount || 2}
            onChange={(e) =>
              handleInputChange(
                "indexOptions.columnCount",
                parseInt(e.target.value)
              )
            }
            disabled={disabled}
          >
            <option value="1">{t("sections.index.columnCount.one")}</option>
            <option value="2">{t("sections.index.columnCount.two")}</option>
            <option value="3">{t("sections.index.columnCount.three")}</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="indexTitleRuleSize">
            {t("sections.index.titleRuleSize")}
          </label>
          <select
            id="indexTitleRuleSize"
            className="form-input"
            value={config.indexOptions?.titleRuleSize || 10}
            onChange={(e) =>
              handleInputChange(
                "indexOptions.titleRuleSize",
                parseInt(e.target.value)
              )
            }
            disabled={disabled}
          >
            <option value="9">9px</option>
            <option value="10">10px</option>
            <option value="11">11px</option>
            <option value="12">12px</option>
            <option value="13">13px</option>
            <option value="14">14px</option>
            <option value="15">15px</option>
            <option value="16">16px</option>
            <option value="17">17px</option>
            <option value="18">18px</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="indexLineSpacing">
            {t("sections.index.lineSpacing")}
          </label>
          <select
            id="indexLineSpacing"
            className="form-input"
            value={config.indexOptions?.lineSpacing || 1.1}
            onChange={(e) =>
              handleInputChange(
                "indexOptions.lineSpacing",
                parseFloat(e.target.value)
              )
            }
            disabled={disabled}
          >
            <option value="1.0">1.0</option>
            <option value="1.05">1.05</option>
            <option value="1.1">1.1</option>
            <option value="1.15">1.15</option>
            <option value="1.2">1.2</option>
            <option value="1.25">1.25</option>
            <option value="1.3">1.3</option>
            <option value="1.4">1.4</option>
            <option value="1.5">1.5</option>
            <option value="1.6">1.6</option>
            <option value="1.8">1.8</option>
            <option value="2.0">2.0</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="indexSectionFontSize">
            {t("sections.index.sectionRuleSize")}
          </label>
          <select
            id="indexSectionFontSize"
            className="form-input"
            value={config.indexOptions?.sectionRuleSize || 12}
            onChange={(e) =>
              handleInputChange(
                "indexOptions.sectionRuleSize",
                parseInt(e.target.value)
              )
            }
            disabled={disabled}
          >
            <option value="8">8px</option>
            <option value="9">9px</option>
            <option value="10">10px</option>
            <option value="11">11px</option>
            <option value="12">12px</option>
            <option value="13">13px</option>
            <option value="14">14px</option>
            <option value="15">15px</option>
            <option value="16">16px</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="indexChapterRuleSize">
            {t("sections.index.chapterRuleSize")}
          </label>
          <select
            id="indexChapterRuleSize"
            className="form-input"
            value={config.indexOptions?.chapterRuleSize || 13}
            onChange={(e) =>
              handleInputChange(
                "indexOptions.chapterRuleSize",
                parseInt(e.target.value)
              )
            }
            disabled={disabled}
          >
            <option value="11">11px</option>
            <option value="12">12px</option>
            <option value="13">13px</option>
            <option value="14">14px</option>
            <option value="15">15px</option>
            <option value="16">16px</option>
            <option value="17">17px</option>
            <option value="18">18px</option>
            <option value="19">19px</option>
            <option value="20">20px</option>
          </select>
        </div>
      </div>
      <div className="col-span-2 form-group">
        <label className="form-label" htmlFor="fontFamily">
          🔤 {t("sections.index.fontFamily")}
        </label>
        <select
          id="fontFamily"
          className={clsx("form-input", {
            "opacity-50 cursor-not-allowed": disabled,
            "hover:border-primary-400 focus:border-primary-500": !disabled,
          })}
          value={config.indexOptions?.fontFamily || "TimesRoman"}
          onChange={(e) =>
            handleInputChange("indexOptions.fontFamily", e.target.value)
          }
          disabled={disabled}
        >
          {fontFamilyOptions.map((option) => (
            <option key={option} value={option}>
              {t(`pdfGenerator.fontFamily.${option}`)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default IndexConfigSection;
